import React from "react";
import Form from 'react-bootstrap/Form'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index";
import InputGroup from "react-bootstrap/InputGroup";
import FormDelimiter from "../FormDelimiter";
import * as yup from 'yup';

export const schemaItem = yup.object().shape({
    description: yup.string().max(250, 'Max length is 250').matches(/^[\x00-\x7F]+$/, 'Non-English letters are disallowed').required('Required'),
    // hs_code: yup.string().min(6, 'Min length is 6').max(10, 'Max length is 10').matches(/^\d+$/, 'Only digits').required('Required'),
    quantity: yup.number().typeError('Must be a number').integer('Must be integer').positive('Must be positive').required('Required'),
    price: yup.number().typeError('Must be a number').positive('Must be positive').min(0.01, '0.01 is minimal value').required('Required'),
});

export class ItemsUA extends React.Component {
    state = {};

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            setFieldValue,
        } = this.props;

        let total = 0;
        let subtotal = 0;
        let i;
        for (i of values.items) {
            subtotal = parseFloat((i.price * i.quantity).toFixed(2));
            total += subtotal;
        }
        total = total.toFixed(2);

        return (
            <div>
                <Form.Group>
                    <FormDelimiter text="ITEMS"/>
                    <ol>
                        {values.items.map((item, index) => (
                            <li key={index}>
                                <Form.Group>
                                    <Row>
                                        <Col sm="8">
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>
                                                        <small>Description</small>
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    name={`items.${index}.description`}
                                                    value={item.description}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        this.touchedAndErrorsHasItemsIndex(index, touched, errors) &&
                                                        touched.items[index].description &&
                                                        !!errors.items[index].description
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {
                                                        errors.items &&
                                                        errors.items[index] &&
                                                        errors.items[index].description
                                                    }</Form.Control.Feedback>
                                            </InputGroup>
                                        </Col>

                                        <Col sm="4">
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>
                                                        <small>HS</small>
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control as="select"
                                                    name={`items.${index}.hs_code`}
                                                    value={item.hs_code}
                                                    onChange={handleChange}
                                                >
                                                    <option value="68125000">Clothing</option>
                                                    <option value="84733099">Electronics</option>
                                                    <option value="85166000">Home Appliances</option>
                                                    <option value="85369090">Smart Devices</option>
                                                    <option value="33049900">Beauty & Health</option>
                                                    <option value="96050090">Home Products</option>
                                                    <option value="49019900">Printing</option>
                                                    <option value="33061020">Kids Items</option>
                                                    <option value="95059090">Gifts</option>
                                                    <option value="21069099">Food</option>
                                                    <option value="82055990">Tools</option>
                                                    <option value="84314390">Plumbing</option>
                                                    <option value="82019000">Garden</option>
                                                    <option value="95069990">Sport & Hobby</option>
                                                    <option value="62171000">Other</option>
                                                </Form.Control>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </Form.Group>

                                <Form.Group>
                                    <Row className="mb-5">
                                        <Col sm="4">
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>
                                                        <small>Quantity</small>
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="number"
                                                    name={`items.${index}.quantity`}
                                                    value={item.quantity}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        this.touchedAndErrorsHasItemsIndex(index, touched, errors) &&
                                                        touched.items[index].quantity &&
                                                        !!errors.items[index].quantity
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {
                                                        errors.items &&
                                                        errors.items[index] &&
                                                        errors.items[index].quantity
                                                    }
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Col>
                                        <Col sm="4">
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>
                                                        <FontAwesomeIcon icon="dollar-sign"/>
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    name={`items.${index}.price`}
                                                    value={item.price}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onFocus={e => {
                                                        e.target.select()
                                                    }}
                                                    isInvalid={
                                                        this.touchedAndErrorsHasItemsIndex(index, touched, errors) &&
                                                        touched.items[index].price &&
                                                        !!errors.items[index].price
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {
                                                        errors.items &&
                                                        errors.items[index] &&
                                                        errors.items[index].price
                                                    }
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Col>
                                        <Col sm="3">
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>
                                                        <small>Subtotal</small>
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    readOnly
                                                    value={(item.price * item.quantity).toFixed(2)}
                                                />
                                            </InputGroup>
                                        </Col>
                                        <Col sm="1">
                                            <Button
                                                title="Delete Item"
                                                disabled={values.items.length === 1}
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    values.items.splice(index, 1);
                                                    this.setState(this.state);  // trigger rerender component
                                                }}
                                            >
                                                <FontAwesomeIcon icon="trash"/>
                                            </Button>

                                        </Col>
                                    </Row>
                                </Form.Group>

                            </li>
                        ))}
                    </ol>
                </Form.Group>

                <Form.Group>
                    <Row className="mb-1">
                        <Col sm="8">
                            <Button
                                className="btn btn-success mr-3"
                                onClick={() => {
                                    const nextIndex = values.items.length;
                                    setFieldValue(`items.${nextIndex}`, {
                                        description: '',
                                        quantity: 1,
                                        price: 0.00,
                                        hs_code: '68125000',
                                    })
                                }
                                }
                            >
                                New Item
                            </Button>

                        </Col>
                        <Col sm="4">
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <small>Total</small>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                    readOnly
                                    value={total}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                </Form.Group>
            </div>
        )
    }

    touchedAndErrorsHasItemsIndex = (index, touched, errors) => {
        return touched.items && touched.items[index] && errors.items && errors.items[index];
    };
}

